import { useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';

import {
  COOKIE_NAMES,
  STORAGE_KEYS,
  getCookie,
  toastService,
} from '@fly/shared';

export function useMultipleTeamsToast(isAuthenticated: boolean) {
  const { t } = useTranslation();
  const shownRef = useRef(false);

  useEffect(() => {
    if (!isAuthenticated || shownRef.current) return;
    if (localStorage.getItem(STORAGE_KEYS.MULTIPLE_TEAMS_TOAST_SHOWN)) return;

    const userTeams = getCookie(COOKIE_NAMES.USER_TEAMS);
    if (!userTeams) return;

    const teams = userTeams.split(',').filter(Boolean);
    if (teams.length <= 1) return;

    shownRef.current = true;
    localStorage.setItem(STORAGE_KEYS.MULTIPLE_TEAMS_TOAST_SHOWN, 'true');

    toastService.info(
      t('app.auth.multiple_teams', {
        defaultValue:
          'You are a member of multiple teams. You are currently signed in to {{teamName}}. You need to opt-out of this team to sign in to another team.',
        teamName: getCookie(COOKIE_NAMES.TEAM_NAME),
      }),
      { autoClose: false }
    );
  }, [isAuthenticated, t]);
}
